<template>
  <div>
    <v-dialog v-model="remarksDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="title">Cancel</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding-left: 20px">Are you sure you want to Cancel this {{ title }}{{ type==="multiple" ? "(s)" : "" }}?</v-card-text>
        <v-textarea 
            solo 
            name="input-7-4" 
            label="Please input remarks here"
            v-model="remarks"
            style="padding: 0 20px 0 20px"
        ></v-textarea>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <v-btn slot="activator" flat @click="saveCancelDialog">
              <v-icon color="green">check</v-icon>
            </v-btn>
            <span>Yes</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn slot="activator" flat @click="closeCancelDialog">
              <v-icon color="pink">close</v-icon>
            </v-btn>
            <span>No</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    remarksDialog: Boolean,
    title: String,
    type: String,
  },
  data() {
    return {
        remarks: ""
    };
  },
  methods: {
    saveCancelDialog() {
      this.$emit("saveCancelDialog");
    },
    closeCancelDialog() {
      this.$emit("closeCancelDialog");
    }
  }
};
</script>